import React, {memo, Suspense} from "react"
import {MANIFEST} from "@manifest/header"
import {useTemplatedComponent} from "@next/templating"
import {SuggestionItem} from "models/autocomplete"
import {TemplateSettingsModel} from "models/templates"
import connect from "./connect"

export type AutoCompleteProps = {
    isLoading: boolean
    isNoResults: boolean | null
    getAutoCompleteThunk: ({term, parameters, cookie}: {term: string; parameters: any; cookie: string}) => void
    numFound: number
    suggestions: SuggestionItem[] | null
    text: any
    children?: React.ReactNode
    templating: TemplateSettingsModel
    cookie?: string
    parameters: any
    xxlBreakpointEnabled: boolean
    showSelectionHighlight: boolean
}

export const EnrichAutoComplete = memo(({templating, children, ...props}: AutoCompleteProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)
    return (
        <Suspense>
            <ComponentName {...props}>{children}</ComponentName>
        </Suspense>
    )
})
EnrichAutoComplete.displayName = "EnrichAutoComplete"

export default connect(EnrichAutoComplete)
